import { selectJBPSettingsCurrentFYear } from 'legacy/lut/features/partner360/jbpSettings'
import { createSelector } from 'reselect'

import { selectBusinessPrioritiesSelectedFYear } from './selectBusinessPrioritiesSelectedFYear'

export const selectIsBusinessPrioritiesPreviousFYearSelected = createSelector(
  [selectBusinessPrioritiesSelectedFYear, selectJBPSettingsCurrentFYear],
  (selectedFYear, currentFYear) => selectedFYear !== currentFYear
)
